/*
 * @Author: jyy 
 * @Date: 2024-12-24 15:21:02 
 * @Last Modified by: jyy
 * @Last Modified time: 2025-01-10 16:44:07
 */
<template>
    <div class="tip-card">
        <div class="top">
            <img class="free-label" src="@/assets/list/hotel-scenic-new-list-free-tag.png" alt="">
            <span class="title">订酒店，免费赠送景点门票</span>
        </div>
        <div class="desc">成功购买酒店后，在酒店订单详情立即领取</div>
        <div class="desc">每笔酒店订单仅支持领取 1份门票,赠完为止</div>
        <div class="desc">领取需<span class="color">支付0.01元</span>用于系统创建门票订单</div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
    watch: {},
    computed: {},
    created() { },
    mounted() { },
    methods: {}
}
</script>

<style lang='scss' scoped>
@import '@/scss/_vars.scss';

.tip-card {
    margin: 12 * $px 12 * $px 0;
    background-image: linear-gradient(179deg, #ffffff99 0%, #ffffff 100%);
    border-radius: 12 * $px;
    padding: 12 * $px;
    box-sizing: border-box;

    .top {
        display: flex;
        align-items: center;
        margin-bottom: 8 * $px;
        .free-label {
            width: 71 * $px;
            height: 18 * $px;
        }

        .title {
            font-size: 14 * $px;
            color: #002566;
            font-weight: 500;
            margin-left: 4 * $px;
        }
    }

    .desc {
        font-size: 12 * $px;
        color: #575757;
        padding-left: 10 * $px;
        margin-bottom: 6 * $px;
        position: relative;
        &:last-child {
            margin-bottom: 0;
        }

        .color {
            color: rgba(234, 109, 7, 1);
        }
        &::before {
            content: '';
            display: block;
            width: 2 * $px;
            height: 2 * $px;
            background-color: #587193;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 2 * $px;
        }
    }
}
</style>